/* egift-cart-guard.js  AGSカード販売サイト eギフト購入ルールの点検係（2026-11-04 ヘルメス）
 * ルール：eギフト（品番・ハンドル末尾 -dgtl）は 1注文に1点だけ。他の商品とも一緒に買えない。
 * A：カートに入れる／数量を増やす前に点検し、ルールに合わなければ入れずにお知らせ窓を出す。
 * B：「ご購入手続きへ」を押したときにカートの中身を点検し、合わなければ進まずにお知らせ窓を出す。
 * 点検に失敗した（通信エラー等）ときは止めない＝ふだんどおり買える（購入を壊さないため）。
 */
(function () {
  if (window.__egiftGuard) return;
  window.__egiftGuard = true;

  var _fetch = window.fetch.bind(window);
  var CART_RE = /\/cart\/(add|change|update)(\.js)?\/?$/;
  var variantCache = {};
  var lastCart = null;

  function isEgiftStr(s) { return /-dgtl$/i.test(String(s || '').trim()); }
  function isEgiftItem(i) { return isEgiftStr(i.sku) || isEgiftStr(i.handle); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function kindOf(url) {
    try {
      var u = new URL(typeof url === 'string' ? url : (url && url.url) || '', location.origin);
      if (u.origin !== location.origin) return null;
      var m = u.pathname.match(CART_RE);
      return m ? m[1] : null;
    } catch (e) { return null; }
  }
  function getCart() {
    return _fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (c) { lastCart = c; return c; });
  }
  function variantSku(id, cart) {
    id = String(id);
    var hit = (cart.items || []).filter(function (i) { return String(i.variant_id) === id || String(i.id) === id; })[0];
    if (hit) return Promise.resolve({ egift: isEgiftItem(hit) });
    if (variantCache[id]) return Promise.resolve(variantCache[id]);
    return _fetch('/variants/' + encodeURIComponent(id) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('variant ' + r.status); return r.json(); })
      .then(function (v) { variantCache[id] = { egift: isEgiftStr(v.sku) }; return variantCache[id]; });
  }

  /* ---- 送ろうとしている中身を読む ---- */
  function bodyToObj(body) {
    if (body == null) return null;
    if (typeof FormData !== 'undefined' && body instanceof FormData) return { fd: body };
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return { fd: body };
    if (typeof body === 'string') {
      try { return { json: JSON.parse(body) }; } catch (e) { return { fd: new URLSearchParams(body) }; }
    }
    return null;
  }
  function parseAdd(o) {
    var out = [];
    if (!o) return out;
    if (o.json) {
      var j = o.json;
      if (Array.isArray(j.items)) j.items.forEach(function (i) { if (i && i.id) out.push({ id: i.id, q: +(i.quantity || 1) }); });
      else if (j.id) out.push({ id: j.id, q: +(j.quantity || 1) });
      return out;
    }
    var fd = o.fd;
    if (fd.get('id')) out.push({ id: fd.get('id'), q: +(fd.get('quantity') || 1) });
    var idx = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (m) { idx[m[1]] = idx[m[1]] || {}; idx[m[1]][m[2]] = v; }
    });
    Object.keys(idx).forEach(function (n) { if (idx[n].id) out.push({ id: idx[n].id, q: +(idx[n].quantity || 1) }); });
    return out;
  }
  function count(items) {
    var e = 0, o = 0;
    items.forEach(function (i) { if (i.q > 0) { if (i.egift) e += i.q; else o += i.q; } });
    return { e: e, o: o, bad: e > 1 || (e >= 1 && o >= 1) };
  }
  function cartAsList(cart) {
    return (cart.items || []).map(function (i) {
      return { key: i.key, vid: String(i.variant_id), q: i.quantity, egift: isEgiftItem(i), item: i };
    });
  }

  /* ---- 点検：結果 {ok:true} か {ok:false, type, ...} ---- */
  function checkAdd(o) {
    var adds = parseAdd(o);
    if (!adds.length) return Promise.resolve({ ok: true });
    return getCart().then(function (cart) {
      return Promise.all(adds.map(function (a) { return variantSku(a.id, cart); })).then(function (info) {
        var list = cartAsList(cart);
        var addsInfo = adds.map(function (a, n) { return { vid: String(a.id), q: a.q, egift: info[n].egift }; });
        var after = list.concat(addsInfo);
        if (!count(after).bad) return { ok: true };
        var addingEgift = addsInfo.some(function (a) { return a.egift; });
        return { ok: false, type: addingEgift ? 'addEgift' : 'addOther', cart: cart, adds: addsInfo };
      });
    });
  }
  function checkChange(kind, o) {
    if (!o) return Promise.resolve({ ok: true });
    return getCart().then(function (cart) {
      var list = cartAsList(cart);
      var before = list.map(function (x) { return x.q; });
      var get = function (k) { return o.json ? o.json[k] : o.fd.get(k); };
      if (kind === 'change') {
        var q = get('quantity');
        if (q == null) return { ok: true };
        var t = null, line = get('line'), id = get('id');
        if (line) t = list[+line - 1];
        else if (id != null) t = list.filter(function (x) { return x.key === String(id) || x.vid === String(id); })[0];
        if (!t) return { ok: true };
        t.q = +q;
      } else {
        var ups = o.json ? o.json.updates : null;
        if (o.fd && o.fd.getAll && o.fd.getAll('updates[]').length) ups = o.fd.getAll('updates[]');
        if (!ups) return { ok: true };
        if (Array.isArray(ups)) ups.forEach(function (v, n) { if (list[n]) list[n].q = +v; });
        else Object.keys(ups).forEach(function (k) {
          list.forEach(function (x) { if (x.key === k || x.vid === k) x.q = +ups[k]; });
        });
      }
      var increased = list.some(function (x, n) { return x.q > before[n]; });
      if (!increased || !count(list).bad) return { ok: true };
      return { ok: false, type: 'qty', cart: cart, reload: true };
    });
  }

  /* ---- お知らせ窓 ---- */
  var CSS = '' +
    '.egg-ov{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px}' +
    '.egg-md{background:#fff;color:#333;border-radius:10px;border-top:4px solid #B59768;max-width:440px;width:100%;padding:22px 22px 18px;box-shadow:0 6px 24px rgba(0,0,0,.25);font-size:14px;line-height:1.75;max-height:90vh;overflow:auto}' +
    '.egg-t{font-weight:bold;font-size:15.5px;margin:0 0 8px;color:#101D31}' +
    '.egg-md ul{margin:6px 0 10px;padding-left:20px}.egg-md p{margin:0 0 6px}' +
    '.egg-box{margin:10px 0 12px}' +
    '.egg-box-t{font-size:12.5px;color:#9a7f52;margin:0 0 6px}' +
    '.egg-md ul.egg-ls{list-style:none;margin:0;padding:0}' +
    '.egg-ls li{display:flex;gap:10px;align-items:flex-start;padding:8px 12px;margin:0 0 6px;background:#F8F4EC;border-radius:6px;font-size:13.5px;line-height:1.55}' +
    '.egg-nm{flex:1;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    '.egg-q{white-space:nowrap;color:#9a7f52}' +
    '.egg-bt{display:flex;flex-direction:column;gap:8px;margin-top:14px}' +
    '.egg-b1,.egg-b2,.egg-b3{border-radius:6px;padding:10px 14px;font-size:14px;cursor:pointer;line-height:1.4;font-family:inherit;width:100%}' +
    '.egg-b1{background:#101D31;color:#fff;border:1px solid #101D31}.egg-b2{background:#fff;color:#101D31;border:1px solid #B59768}' +
    '.egg-b3{background:none;border:none;color:#6b7380;text-decoration:underline;padding:4px}' +
    '.cart-item.egg-ng{background:#fff4f2}';
  function ensureCss() {
    if (document.getElementById('egg-css')) return;
    var s = document.createElement('style'); s.id = 'egg-css'; s.textContent = CSS; document.head.appendChild(s);
  }
  function label(i) {
    if (isEgiftItem(i)) return 'eギフト';
    if (/-card$/i.test(i.handle || '')) return '紙カード';
    return '商品';
  }
  function itemLines(cart) {
    return '<div class="egg-box"><div class="egg-box-t">現在のカート内</div><ul class="egg-ls">' + (cart.items || []).map(function (i) {
      var name = i.product_title + (i.variant_title && i.variant_title !== 'Default Title' ? '（' + i.variant_title + '）' : '');
      return '<li><span class="egg-nm">' + esc(name) + '</span><span class="egg-q">×' + i.quantity + '</span></li>';
    }).join('') + '</ul></div>';
  }
  function modal(title, html, buttons) {
    ensureCss();
    var old = document.querySelector('.egg-ov'); if (old) old.remove();
    var ov = document.createElement('div'); ov.className = 'egg-ov';
    ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true');
    var md = document.createElement('div'); md.className = 'egg-md';
    md.innerHTML = '<div class="egg-t">' + esc(title) + '</div>' + html + '<div class="egg-bt"></div>';
    var bt = md.querySelector('.egg-bt');
    var close = function () { ov.remove(); };
    buttons.forEach(function (b) {
      var el = document.createElement('button'); el.type = 'button';
      el.className = b.primary ? 'egg-b1' : (b.plain ? 'egg-b3' : 'egg-b2'); el.textContent = b.text;
      el.addEventListener('click', function () { close(); if (b.run) b.run(); });
      bt.appendChild(el);
    });
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    ov.appendChild(md); document.body.appendChild(ov);
    var first = bt.querySelector('.egg-b1') || bt.querySelector('button'); if (first) first.focus();
  }
  function goCart() {
    if (/^\/cart\/?$/.test(location.pathname)) { refreshCartPage(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
    else location.href = '/cart';
  }
  function buyOnly(url, o) {
    var body;
    if (o && o.fd && typeof FormData !== 'undefined' && o.fd instanceof FormData) { body = new FormData(); o.fd.forEach(function (v, k) { if (k !== 'sections' && k !== 'sections_url') body.append(k, v); }); body.set('quantity', '1'); }
    else {
      var eg = (parseAdd(o).filter(function (a) { return variantCache[String(a.id)] && variantCache[String(a.id)].egift; })[0]) || parseAdd(o)[0];
      body = JSON.stringify({ items: [{ id: eg.id, quantity: 1 }] });
    }
    var headers = typeof body === 'string' ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' };
    _fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function () { return _fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: headers, body: body }); })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); location.href = '/checkout'; })
      .catch(function () { location.href = '/cart'; });
  }
  function goCheckout() {
    getCart().then(function (cart) {
      if (!count(cartAsList(cart)).bad) location.href = '/checkout';
      else showBlocked({ ok: false, type: 'checkout', cart: cart });
    }).catch(function () { location.href = '/cart'; });
  }
  var NOTE = 'eギフトは1点ずつのご注文です。複数ご希望の場合は、お手数ですが1つずつご注文ください。';
  function showBlocked(res, url, o) {
    if (res.type === 'addEgift') {
      modal('eギフトは、1回のご注文で1点のみです',
        '<p>ご注文ごとに専用URLを1つお送りするため、他の商品と一緒にはご購入いただけません。</p>' + itemLines(res.cart),
        [{ text: 'カートの商品を外して、このeギフトだけ購入する', primary: true, run: function () { buyOnly(url, o); } },
         { text: 'カートを見る', run: goCart }, { text: 'やめる', plain: true }]);
    } else if (res.type === 'addOther') {
      modal('カートにeギフトが入っています',
        '<p>eギフトは、他の商品と一緒にはご購入いただけません。先にeギフトのご購入を済ませてください。</p>' + itemLines(res.cart),
        [{ text: 'eギフトの購入手続きへ', primary: true, run: goCheckout }, { text: '閉じる', plain: true }]);
    } else if (res.type === 'qty') {
      modal('eギフトは1点ずつのご注文となります', '<p>複数ご希望の場合は、お手数ですが1つずつご注文ください。</p>',
        [{ text: '閉じる', primary: true, run: function () { if (res.reload && /^\/cart\/?$/.test(location.pathname)) location.reload(); } }]);
    } else if (res.cart && (res.cart.items || []).length === 1) {
      modal('このままではご購入手続きに進めません',
        '<p>eギフトは、1回のご注文で1点のみです。</p>' + itemLines(res.cart) +
        '<p>カート画面で数量を1にしてから、お進みください。</p>',
        [{ text: 'カートに戻って直す', primary: true, run: goCart }]);
    } else {
      modal('このままではご購入手続きに進めません',
        '<p>eギフトは、1回のご注文で1点のみ・他の商品とは別のご注文でお願いしております。</p>' + itemLines(res.cart) +
        '<p>カート画面でどちらかを削除してから、お進みください。</p>',
        [{ text: 'カートに戻って直す', primary: true, run: goCart }]);
    }
  }
  function blockedError() { var e = new Error('egift-guard: blocked'); e.name = 'EgiftGuardBlocked'; return e; }
  function guardCheck(kind, body) {
    var o = bodyToObj(body);
    return kind === 'add' ? checkAdd(o) : checkChange(kind, o);
  }

  /* ---- A：fetch / XMLHttpRequest でカートを触る前に点検 ---- */
  window.fetch = function (input, init) {
    var kind = kindOf(input);
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (!kind || method !== 'POST') return _fetch(input, init);
    var body = init && init.body;
    return guardCheck(kind, body).catch(function () { return { ok: true }; }).then(function (res) {
      if (res.ok) return _fetch(input, init).then(function (r) { setTimeout(refreshCartPage, 400); return r; });
      showBlocked(res, input, bodyToObj(body));
      throw blockedError();
    });
  };
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__eggKind = String(m).toUpperCase() === 'POST' ? kindOf(url) : null; return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this, kind = xhr.__eggKind;
    if (!kind) return XS.call(xhr, body);
    guardCheck(kind, body).catch(function () { return { ok: true }; }).then(function (res) {
      if (res.ok) { XS.call(xhr, body); setTimeout(refreshCartPage, 800); return; }
      showBlocked(res, null, bodyToObj(body));
      try { xhr.dispatchEvent(new Event('error')); xhr.dispatchEvent(new Event('loadend')); } catch (e) {}
    });
  };

  /* 通常の（JSを使わない）フォーム送信で /cart/add へ入れる場合 */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || f.__eggPass) return;
    var action = f.getAttribute('action') || '';
    if (kindOf(action) !== 'add' || e.defaultPrevented) return;
    e.preventDefault();
    var fd = new FormData(f);
    checkAdd({ fd: fd }).catch(function () { return { ok: true }; }).then(function (res) {
      if (res.ok) { f.__eggPass = true; f.submit(); }
      else showBlocked(res, action, { fd: fd });
    });
  }, false);

  /* カート画面：eギフト行の「＋」（上限1で押せない）を押そうとしたら、理由をお知らせする */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button[name="plus"]');
    if (!b) return;
    var row = b.closest('.cart-item');
    var inp = b.closest('quantity-input') && b.closest('quantity-input').querySelector('input');
    if (!row || !row.querySelector('.egg-note') || !inp) return;
    if (+inp.value >= +(inp.max || 1)) { e.preventDefault(); e.stopImmediatePropagation(); showBlocked({ ok: false, type: 'qty' }); }
  }, true);

  /* ---- B：「ご購入手続きへ」を押したとき ---- */
  var passCheckout = false;
  function isCheckoutEl(el) {
    if (!el || !el.closest) return null;
    return el.closest('button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout, a[href^="/checkout"], a[href*="/checkout?"]');
  }
  document.addEventListener('click', function (e) {
    var el = isCheckoutEl(e.target);
    if (!el || passCheckout) return;
    e.preventDefault(); e.stopImmediatePropagation();
    getCart().then(function (cart) {
      var c = count(cartAsList(cart));
      if (!c.bad) { passCheckout = true; el.click(); setTimeout(function () { passCheckout = false; }, 3000); return; }
      showBlocked({ ok: false, type: 'checkout', cart: cart });
      refreshCartPage();
    }).catch(function () { passCheckout = true; el.click(); setTimeout(function () { passCheckout = false; }, 3000); });
  }, true);

  /* ---- カート画面：ルールに合わない行に色を付け、急ぎ決済ボタンを隠す ---- */
  function applyCartPage(cart) {
    if (!/^\/cart\/?$/.test(location.pathname) || !cart) return;
    ensureCss();
    var list = cartAsList(cart), c = count(list), mixed = c.e >= 1 && c.o >= 1;
    list.forEach(function (x, n) {
      var row = document.getElementById('CartItem-' + (n + 1));
      if (!row) return;
      var ng = c.bad && (mixed || (x.egift && x.q > 1));
      row.classList.toggle('egg-ng', !!ng);
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function (b) {
      b.style.display = c.bad ? 'none' : '';
    });
  }
  function refreshCartPage() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    getCart().then(applyCartPage).catch(function () {});
  }
  function init() {
    refreshCartPage();
    var host = document.getElementById('main-cart-items');
    if (host && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { applyCartPage(lastCart); }, 50); })
        .observe(host, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
